//import LoadingComponent from "@/pcomponents/common/content/loading";
/*
const [loading_data, set_loading_data] = useState({
  is_display: false,
  text: "저장 되었습니다.",
});
set_loading_data({
  is_display: true,
  text: "저장 중입나다.",
});
set_loading_data({
  is_display: true,
  text: "저장 되었습니다.",
});
setTimeout(() => {
  set_loading_data({
    ...loading_data,
    is_display: false,
  });
}, 600);
<LoadingComponent is_display={loading_data.is_display} text={loading_data.text}></LoadingComponent>
*/
import { useEffect, useRef } from 'react';
function LoadingComponent(props: any) {
  let myProps = {
    is_display: true,
    text: "로딩중..",
    loading_style: {},
    is_show_loading_img: true,
    loading_img: process.env.REACT_APP_API_URL + "/img/common/loading/loading3.gif",
    ...props
  };

  const popupBackDiv = useRef<HTMLInputElement>(null);
  useEffect(() => {
    popupBackDiv.current?.addEventListener("click", (e: any) => {
      if (e.target.classList.contains('popup-background')) {

      }
      return false;
    }, false);
  }, []);

  let loading_style: any = {
    position: "fixed",
    left: 0,
    top: "40%",
    width: "100%",
    textAlign: "center",
    display: "none",
    zIndex: 99,
    cursor: "pointer",
    ...myProps.loading_style
  };
  if (myProps.is_display) {
    loading_style["display"] = "block";
  }
  let text_box_style: any = {
    display: "inline-block",
    background: "#fff",
    padding: 15,
    border: "1px solid #ddd",
    textAlign: "center",
    borderRadius: "5px",
  };
  let text_span_style: any = {
    color: "#379d89",
    background: "#fff",
    lineHeight: "30px",
    padding: "0px 15px",
    fontWeight: "bold",
    fontSize: 15
  };
  return (
    <>
      {myProps.is_display &&
        <div className="popup-background" ref={popupBackDiv} >
          <div className="popup-transparent-back"></div>
          <div style={loading_style}>
            <div style={text_box_style}>
              <div>
                {myProps.is_show_loading_img &&
                  <img src={myProps.loading_img} />
                }
              </div>
              <span style={text_span_style}>
                {myProps.text}
              </span>
            </div>
          </div>
        </div>
      }
    </>
  );
}
export default LoadingComponent;